import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import { roles } from '../../constants/roles';
import getSalesAgentById from '../SalesAgents/getSalesAgentById.api';

const firebaseRef = firebase.database();
export default async function getAllLeads(role, callback) {
	if (role === roles.superadmin) {
		console.log('get all leads I am in the superadmin');
		await firebaseRef
			.ref('/kavtek_leads/' + PROJECT_CODE.projectCode)
			.on('value', (snapshot) => {
				var leadClientsArr = [];
				var snapData = snapshot.val();
				var allKeys = snapData && Object.keys(snapData);
				if (
					allKeys !== null &&
					allKeys !== undefined &&
					allKeys.length > 0
				) {
					allKeys.forEach((leadsKey) => {
						console.log('leadsKeyleadsKey', leadsKey);
						var leadClientsEmails =
							snapData[leadsKey]['clientEmail'];
						var leadClientsSentEmail =
							snapData[leadsKey]['sentEmail'];
						var salesAgent = snapData[leadsKey]['leadToSalesAgent'];
						var leadsPhoneNumber =
							snapData[leadsKey]['clientPhoneNumber'];
						var status;
						var leadsPostalCode = snapData[leadsKey]['postalCode'];
						var buyerType = snapData[leadsKey]['buyerType'];
						var city = snapData[leadsKey]['city'];
						var clientFName = capitalize(
							snapData[leadsKey]['clientFName']
						);
						var clientLName = capitalize(
							snapData[leadsKey]['clientLName']
						);
						var comments = snapData[leadsKey]['comments'];
						var createTimestamp =
							snapData[leadsKey]['createTimestamp'];
						var desiredPrice = snapData[leadsKey]['desiredPrice'];
						var desiredSize = snapData[leadsKey]['desiredSize'];
						var mortgageQualification =
							snapData[leadsKey]['mortgageQualification'];
						var realStateAgent =
							snapData[leadsKey]['realStateAgent'];
						var reference = snapData[leadsKey]['reference'];
						var identification = snapData[leadsKey]?.identification;

						var salesAgentName;

						getSalesAgentById(salesAgent, (returned) => {
							salesAgentName = returned?.fullName;
						});

						if (leadClientsSentEmail === true) {
							status = 1;
						} else if (leadClientsSentEmail !== true) {
							status = 0;
						}
						var leadClients = {
							leadsKey: leadsKey,
							email: leadClientsEmails,
							postalCode: leadsPostalCode,
							sentEmail: status,
							salesAgent: salesAgent,
							salesAgentName: salesAgentName || '',
							leadsPhoneNumber: leadsPhoneNumber,
							buyerType: buyerType,
							city: city,
							clientFName: clientFName,
							clientLName: clientLName,
							comments: comments,
							createTimestamp: createTimestamp,
							desiredPrice: desiredPrice,
							desiredSize: desiredSize,
							mortgageQualification: mortgageQualification,
							realStateAgent: realStateAgent,
							reference: reference,
							leadId: leadsKey,
							identification: identification,
						};
						leadClientsArr.push(leadClients);
					});
				}
				callback(leadClientsArr);
			});
	} else if (role === roles.admin || role === roles.cobroker) {
		console.log('get all leads I am in the admin');
		var currrentUser = firebase.auth().currentUser.uid;
		await firebaseRef
			.ref('/kavtek_leads/' + PROJECT_CODE.projectCode)
			.orderByChild('leadToSalesAgent')
			.equalTo(currrentUser)
			.on('value', (snapshot) => {
				var leadClientsArr = [];
				var snapData = snapshot.val();
				var allKeys = snapData && Object.keys(snapData);
				if (
					allKeys !== null &&
					allKeys !== undefined &&
					allKeys.length > 0
				) {
					allKeys.forEach((leadsKey) => {
						console.log('leadsKeyleadsKey', leadsKey);
						var leadClientsEmails =
							snapData[leadsKey]['clientEmail'];
						var leadClientsSentEmail =
							snapData[leadsKey]['sentEmail'];
						var salesAgent = snapData[leadsKey]['leadToSalesAgent'];
						var leadsPhoneNumber =
							snapData[leadsKey]['clientPhoneNumber'];
						var status;
						var leadsPostalCode = snapData[leadsKey]['postalCode'];
						var buyerType = snapData[leadsKey]['buyerType'];
						var city = snapData[leadsKey]['city'];
						var clientFName = capitalize(
							snapData[leadsKey]['clientFName']
						);
						var clientLName = capitalize(
							snapData[leadsKey]['clientLName']
						);
						var comments = snapData[leadsKey]['comments'];
						var createTimestamp =
							snapData[leadsKey]['createTimestamp'];
						var desiredPrice = snapData[leadsKey]['desiredPrice'];
						var desiredSize = snapData[leadsKey]['desiredSize'];
						var mortgageQualification =
							snapData[leadsKey]['mortgageQualification'];
						var realStateAgent =
							snapData[leadsKey]['realStateAgent'];
						var reference = snapData[leadsKey]['reference'];
						var identification = snapData[leadsKey]?.identification;
						var salesAgentName;

						if (leadClientsSentEmail === true) {
							status = 1;
						} else if (leadClientsSentEmail !== true) {
							status = 0;
						}
						var leadClients = {
							leadsKey: leadsKey,
							email: leadClientsEmails,
							postalCode: leadsPostalCode,
							sentEmail: status,
							salesAgent: salesAgent,
							leadsPhoneNumber: leadsPhoneNumber,
							buyerType: buyerType,
							city: city,
							clientFName: clientFName,
							clientLName: clientLName,
							comments: comments,
							createTimestamp: createTimestamp,
							desiredPrice: desiredPrice,
							desiredSize: desiredSize,
							mortgageQualification: mortgageQualification,
							realStateAgent: realStateAgent,
							reference: reference,
							leadId: leadsKey,
							identification: identification,
						};
						leadClientsArr.push(leadClients);
					});
				}
				callback(leadClientsArr);
			});
	}
}
function capitalize(string) {
	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
